(ns nl.mediquest.ui.core.modal
  (:require
   [clojure.spec.alpha :as s]
   [integrant.core :as ig]
   [reagent.core :as r]
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::modal
 (fn [db [_]]
   (get-in db [:nl.mediquest.ui ::modal])))

;; DEPRECATED - use ::open or ::close effect instead
(re-frame/reg-event-db
 ::set-modal
 (fn [db [_ modal]]
   (assoc-in db [:nl.mediquest.ui ::modal] modal)))

(defn open! [modal]
  (re-frame/dispatch [::set-modal modal]))

(defn close! []
  (re-frame/dispatch [::set-modal nil]))

(re-frame/reg-fx
 ::open
 (fn [{:keys [modal]}]
   (open! modal)))

(re-frame/reg-fx
 ::close
 (fn []
   (close!)))

(defn throw-non-component-error [modal]
  (throw (js/Error. (str "ERROR: Modal didn't get a component, instead it got " modal))))

(defn- close-on-escape [^js event]
  (when (= "Escape" (.-key event))
    (close!)))

(defn view []
  (r/with-let [_ (.addEventListener js/window "keydown" close-on-escape)]
    (let [modal (re-frame/subscribe [::modal])]
      (fn []
        (if @modal
          [:<>
           [:div.fixed.w-full.h-full.z-40.bg-black.opacity-25
            {:on-click close!}]
           [:div.fixed.w-full.h-full.pointer-events-none.z-40
            [:div.flex.w-full.h-full.justify-center.items-center
             [:div.relative.pointer-events-auto.m-4.w-full.overflow-auto
              {:style {:max-width "800px"
                       :max-height "85%"}}
              [:div.absolute.right-0.p-2.pr-3.cursor-pointer
               {:on-click close!}
               [:i.fa-close.fal.text-xl]]
              [:div.bg-white.px-8.py-4.rounded-md
               {:style {:border-radius ".375rem"}}
               (when-not (fn? @modal) (throw-non-component-error @modal))
               [@modal]]]]]]
          [:div])))
    (finally
      (.removeEventListener js/window "keydown" close-on-escape))))

(defmethod ig/assert-key :component.ui/modal [_k v]
  (assert (s/valid? (s/keys :req []) v)))

(defmethod ig/init-key :component.ui/modal [_ _opts]
  (fn []
    [view]))
